import { formatInternationalPhoneNumber } from "./formatInternationalPhoneNumber";
import { formatRegularPhoneNumber } from "./formatRegularPhoneNumber";

export const formatPhoneNumber = (
  phoneNumber: string,
  isInternationalPhoneEnabled: boolean,
  phoneFormat: string
): string => {
  return isInternationalPhoneEnabled
    ? formatInternationalPhoneNumber(phoneNumber)
    : formatRegularPhoneNumber(phoneNumber, phoneFormat);
};
